import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Button, CircularProgress, Icon } from '@material-ui/core';
import { FHETextField } from 'data/components';

class FHEMessageSender extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        sendMessageFunc: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            message: '',
            loading: false
        };
    }

    handleChangeMessage = event => {
        let targetValue = event.target.value;
        this.setState({
            message: targetValue
        });
    };

    sendMessage = () => {
        const { message, loading } = this.state;
        const { sendMessageFunc } = this.props;
        if (!loading) this.setState({ loading: true });

        sendMessageFunc(message)
            .then(() => {
                this.setState({
                    message: '',
                    loading: false
                });
            })
            .catch(() => {
                this.setState({
                    loading: false
                });
            });
    };

    render() {
        const { loading, message } = this.state;
        const { classes } = this.props;
        return (
            <div className={classes.messageSender}>
                <FHETextField
                    autoComplete="off"
                    fullWidth
                    id="message"
                    name="message"
                    multiline
                    value={message}
                    label={Translator.translate('general.ticketing.message')}
                    onChange={this.handleChangeMessage}
                    rowsMax="6"
                />
                <div className="d-flex flew-wrap align-items-center">
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={message.length === 0}
                        onClick={this.sendMessage}
                        className={classes.buttonSendMessage}
                    >
                        {Translator.translate('general.ticketing.send')}
                        {loading ? (
                            <CircularProgress size={25} className={classes.buttonSendMessageIcon} />
                        ) : (
                            <Icon className={classes.buttonSendMessageIcon}>send</Icon>
                        )}
                    </Button>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    messageSender: {
        display: 'flex',
        flexWrap: 'no-wrap',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap'
        }
    },
    buttonSendMessage: {
        marginLeft: 10,
        display: 'flex'
    },
    buttonSendMessageIcon: {
        marginLeft: 10
    }
});

export default withStyles(styles, { withTheme: true })(FHEMessageSender);



// WEBPACK FOOTER //
// ./data/components/FHEMessageSender.js